
import * as React from "react";
import { TStorage } from "../../avernus/tstorage/TStorage";
import { Api } from "../lib/Api";
import { Url } from "../../avernus/url/source/Url";
import { Lng } from "../../languages/Languages";
import Config from "../../source/Config";
import { Order } from "./user/Order";


interface IFooterProps {
    setUrl              : any
    homePageMode        ?: boolean
    homePageFigureHide  ?: boolean
    onlyBackBtnText     ?:string
    backBtnClickHandler ?:Function
}

interface IFooterState {
    footerData:IFooterData
}

interface IFooterData{
    orderedMeals: number
    co2         : number
    sobrasCredit: number
}

export default class Footer extends React.Component<IFooterProps, IFooterState>{

    private homePageMode:boolean;

  	constructor(props:IFooterProps){
        super(props);
        this.homePageMode = this.props.homePageMode !== undefined && this.props.homePageMode === true;
        this.state = {
            footerData: {
                orderedMeals: 0,
                co2         : 0,
                sobrasCredit: 0
            }
        };
    }


    private logoutClickHandler(evt): void {
        evt.preventDefault();
        Api.cleanStorage();
        Order.cleanStorage();
        console.log('Logout!', '/login');
        this.props.setUrl('/login');
        // window.location.href = '/login';
    }

    render() {
        var name                = new TStorage().get('name', '');
        var isAdmin             = Api.getPermission().indexOf('admin')>-1?true:false;
        let isAdminPlace:boolean= Url.getUrl().indexOf('admin') > -1;
        let firstUrl            = Url.getUrlPart(0);
        return (
            <div className="container footer_section">
               { this.homePageMode && isAdminPlace === false?this.homePageFooter(name, isAdmin):<>
                    { isAdminPlace === true?this.adminFooter(name, isAdmin):'' }
                    { firstUrl === 'restaurant'?this.restaurantFooter(name, isAdmin):'' }
                    { firstUrl === 'user'?this.defaultFooter(name, isAdmin):'' }
                </> }
            </div>
        );
    }

    private homePageFooter(name: any, isAdmin: boolean) {
        return <div className="footer home_page_footer"/>;
    }
    private defaultFooter(name: any, isAdmin: boolean) {
        return <div className="row footer default_foooter">
                    { Api.isFrontUser()===true?<>
                    <div className="col-4 text-center">
                        <a onClick={e => {
                            e.preventDefault();
                            this.props.setUrl('/user/favourite-restaurants');
                        } }>
                            <img src="img/favorite_professional_icon.svg" width={33} alt=""/>
                            <p>
                                My favorite<br/>
                                Professionals
                            </p>
                        </a>
                    </div>
                    <div className="col-4 text-center">
                        <a onClick={e => {
                            e.preventDefault();
                            this.props.setUrl('/user/map-search');
                        } }>
                            <img src="img/map_search_iconv2.svg" width={27} alt=""/>
                            <p>
                                Map<br/>
                                Search
                            </p>
                        </a>
                    </div>
                    <div className="col-4 text-center">
                        <a onClick={e => {
                            e.preventDefault();
                            this.props.setUrl('/user/restaurants-you-ordered-from');
                        } }>
                            <img src="img/previous_order_icon.svg" width={27} alt=""/>
                            <p>
                                Previous<br/>
                                Assignments
                            </p>
                        </a>
                    </div>

                    </>:''}

        </div>;
    }

    private adminFooter(name: any, isAdmin: boolean) {
        return <div className="footer restaurant_footer admin_footer">
            <div>
                <span>Loged in: <strong>{name}</strong></span>
            </div>
            {/* <div className="col-2 col-sm-1 d-flex flex-grow-0 justify-content-end align-items-center">
                {isAdmin === true ? <a className="text" onClick={e => {
                    e.preventDefault();
                    this.props.setUrl('/admin');
                } }>Admin</a> : ''}
            </div> */}

            <a className="logut_btn" onClick={e => this.logoutClickHandler(e)}>
                <i className="ion-log-out"></i>
            </a>
        </div>;
    }

    private restaurantFooter(name: any, isAdmin: boolean) {
        return <></>;
    }
}
